// extracted by mini-css-extract-plugin
module.exports = {"col":"style_col__cEx2y","box":"style_box__ZUf8e"};